import { Livelib } from 'Lib/livelib/Livelib';
import { onScreen } from 'Lib/on-screen/on-screen';
import { onWindowLoaded } from 'Lib/on-window-loaded/on-window-loaded';

const elParent = document.querySelector('.book-page__livelib-reviews');

function load(elCurrentParent) {
    if (elCurrentParent) {
        const id = elCurrentParent.getAttribute('data-id');
        const elTarget = elCurrentParent.querySelector('.book-page__livelib-reviews-target');

        if (typeof id === 'string' && id.length && elTarget) {
            const livelib = new Livelib(id);

            livelib.getReviewsHtml()
                .then((html) => {
                    if (typeof html === 'string' && html.length) {
                        elTarget.innerHTML = html;
                        elCurrentParent.classList.add('book-page__livelib-reviews_loaded');
                        $(elTarget).find('.spoiler').trigger('eksmo.spoiler.init');

                        return Promise.resolve(html);
                    }

                    return Promise.reject();
                })
                .catch(() => {
                    document.querySelector('.book-page__tabs-reviews-link').classList.add('book-page__tabs-reviews-link_active');
                    document.querySelector('.book-page__tabs-reviews-link_livelib').remove();
                    document.querySelector('.book-page__tabs-reviews-container').classList.add('book-page__tabs-reviews-container_active');
                    document.querySelector('.book-page__tabs-reviews-container_livelib').classList.remove('book-page__tabs-reviews-container_active');
                });
        }
    }
}

if (elParent) {
    if (document.querySelector('[href="#reviews-livelib"]')) {
        onWindowLoaded()
            .then(() => load(elParent));
    } else {
        onScreen($(elParent), ($parent) => {
            load($parent[0]);
        }, 1000);
    }
}